import { gql } from '@apollo/client';

export const GET_PRICE_PERIODS = gql`
  query GetBillingPackagePeriods {
    billingPackagePeriods
  }
`;

export const GET_PRICES = gql`
  query GetBillingPackageOptions($period: String, $basePlansOnly: Boolean) {

    billingPackageOptions(period: $period, basePlansOnly: $basePlansOnly) {
      billingPackageOptionId
      packagePeriod
      stripePrice
      isBasePlan
      billingPackage {
        billingPackageId
        tier {
          name
          description
          volunteerLimit
          adminLimit
          programManagerLimit
        }
        packageType
        stripeProduct
      }
    }
  }
`;
